import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

/**
 * Custom hook to determine if a customer is a transfer
 * @param customerId
 * @param customerData
 */
const useIsTransfer = (customerId: string, customerData: { isYard: boolean }) => {
  const [isTransfer, setIsTransfer] = useState(false)

  useEffect(() => {
    if (!customerId) {
      setIsTransfer(false)
    } else if (customerData) {
      setIsTransfer(customerData.isYard)
    }
  }, [customerId, customerData])

  return isTransfer
}

export default useIsTransfer
